export function round(float: number): number
{
  const valueToAdd = (float >= 0) ? 0.5 : -0.5;
  return (float + valueToAdd) | 0; //more optimized round function
}

export function randomBetween0And(number: number): number
{
  return round(Math.random() * number);
}

export function isBetween(x: number, min: number, max: number): boolean
{
  return x >= min && x <= max;
}

export function randomBetween2Integers(min: number, max: number): number
{
  return Math.random() * (max - min) + min;
}

export function avg(numbers: Array<number>): number
{
  const sum = numbers.reduce((acc: number, current: number) =>
  {
    return acc + current;
  }, 0);
  return sum / numbers.length;
}